import {Lightbox} from '../../classes/Lightbox';

const initCds2VideoLibrary = () => {
	const sectionVideoLibrary = document.querySelectorAll( 'section.cds2-video-library' );

	if ( !sectionVideoLibrary.length )
	{
		return;
	}

	const closeLightBox = ( lightBox ) => {
		lightBox.addEventListener( 'click', ( {target} ) => {
			if ( !target.closest( 'div.content' ) )
			{
				lightBox.querySelector( 'button.close' ).click();
			}
		}, true );
	};

	sectionVideoLibrary.forEach( ( component ) => {
		const videoWrapper = component.querySelector( 'ul' );

		if ( !videoWrapper )
		{
			return;
		}

		videoWrapper.addEventListener( 'click', ( evt ) => {
			const target = evt.target;
			
			if ( target.closest( 'a' ) )
			{
				evt.preventDefault();
				evt.stopPropagation();

				const url = target.closest( 'a' ).href.split( '=' );

				if ( !url.length )
				{
					return;
				}

				Lightbox.open( `<iframe width="1280" height="720" src="https://www.youtube.com/embed/${url[1]}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`, null, 'fullscreen-lightbox' );
				
				const lightBox = Lightbox.getLightbox();

				closeLightBox( lightBox );
			}
		} );
	} );
};

export {
	initCds2VideoLibrary,
};
